import { ORIENTATION } from '@/types/utils';
import clx from 'classnames';
import { ReactElement } from 'react';
import TabledContent from './TableContent';

const TableLine = ({
  label,
  orientation = ORIENTATION.HORIZONTAL,
  children,
}: {
  label: string;
  orientation?: ORIENTATION;
  children: ReactElement<typeof TabledContent> | ReactElement<typeof TabledContent>[];
}) => (
  <div className={clx('flex rounded-sm overflow-hidden', orientation === ORIENTATION.VERTICAL && 'flex-col')}>
    <div
      className={clx(
        'bg-neutral-100  flex items-center justify-center py-4 px-3',
        orientation === ORIENTATION.HORIZONTAL ? 'w-1/3' : 'w-full',
      )}
    >
      <span className="text-neutral-900 font-bold text-center">{label.toUpperCase()}</span>
    </div>
    <div className="bg-neutral-300 flex-1 flex-col items-center py-4 px-6">{children}</div>
  </div>
);

export default TableLine;
